// test2932
(2932 && 0);
